import * as React from "react";
import ISvgProps from "../../../SvgLoader/ISvgProps";
function SvgComputer(props: ISvgProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={60}
      height={60}
      viewBox="8 10 44 39"
      fill="none"
      {...props}
    >
      <path
        fill={props.primaryColor}
        stroke="#fff"
        strokeWidth={0.2}
        d="M12.885 12.1h34.23c.988 0 1.785.783 1.785 1.754v23.9c0 .968-.817 1.755-1.785 1.755H32.4v5.09h5.5v2.51H23.6V44.6h4.955v-5.09h-15.67a1.9 1.9 0 0 1-.688-.138 1.8 1.8 0 0 1-.58-.383 1.7 1.7 0 0 1-.386-.567 1.7 1.7 0 0 1-.131-.666v-23.9c0-.967.818-1.755 1.785-1.755Zm.815 24.899h32.6v-22.39H13.7z"
      />
      <rect
        width={14.5}
        height={0.5}
        x={16.25}
        y={16.25}
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
        strokeWidth={0.5}
        rx={0.25}
      />
      <rect
        width={6.5}
        height={0.5}
        x={16.75}
        y={19.25}
        fill={props.secondaryColor}
        stroke={props.secondaryColor}
        strokeWidth={0.5}
        rx={0.25}
        transform="rotate(90 16.75 19.25)"
      />
    </svg>
  );
}
export default SvgComputer;
